const icons = {
    setting_lng: "fas fa-globe",
    nav_bar: "fa fa-bars fa-2x",
    menu_nav_home: "fa fa-home",
    table_row_save: "fa fa-save",
    table_row_edit: "far fa-edit",
    lng_sorting_btn: "fas fa-sort",
    menu_nav_settings: "fa fa-cog",
    menu_nav_users: "fa fa-user",
    setting_service: "fas fa-dice-d20",

    //About page
    about_us_category: "fa fa-list",
    about_us_info: "fas fa-info-circle",
    about_us_order: "fas fa-archive",

    setting_about: "far fa-address-book",
    menu_nav_orders: "fab fa-artstation",
    table_row_remove: "fas fa-trash-alt",
    dropdown_arrow_up: "fas fa-caret-up",
    lng_form_remove: "fa fa-times-circle",
    auth_form_icon_eye_open: "far fa-eye",
    menu_items_arrow_up: "fas fa-angle-up",
    side_bar_sign_out: "fas fa-sign-out-alt",
    dropdown_arrow_down: "fas fa-caret-down",
    menu_items_arrow_down: "fas fa-angle-down",
    side_bar_window_close: "fa fa-window-close",
    auth_form_icon_eye_close: "far fa-eye-slash",
    arrow_flip_back: "fas fa-reply",

    //vacancy page
    vacancy_icon: "fa fa-question-circle",

    //transportation to order
    transportation_to_order_icon: "far fa-gem",

    //driving-school
    driving_school_icon: "fas fa-car",

    //road to aeroports
    rta_nav_icon: "fa fa-road",

    //information for tourists
    ift_nav_icon: "fas fa-atlas",

    //international projects
    ip_nav_icon: "fas fa-project-diagram",

    //electricity supply
    es_nav_icon: "fas fa-atom",

    //news
    news_edit_icon: "fa fa-edit",
    news_trash_icons: "fa fa-trash",
    news_remove_icon: "fa fa-times",
    news_nav_icon: "fas fa-bullhorn",

    //road situation
    rs_nav_icon: "fas fa-exclamation-triangle",

    //subscribers
    s_nav_icon: "far fa-comment-dots",

    //tickets
    ticket_icon: "fas fa-ticket-alt"
}

export default icons;